import { Injectable, OnDestroy } from '@angular/core';
import * as moment from 'moment';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs/Rx';

import * as fromRoot from '../store/reducers';
import { TestTakerActions } from './../store/actions';

@Injectable()
export class TimerService implements OnDestroy {

    timer$: Observable<PgRendererDto.Timer>;
    timer: PgRendererDto.Timer;
    isTimerVisible: boolean;
    private timerSubscription: Subscription;
    private timerVisibilitySubscription: Subscription;

    constructor(
        private store: Store<fromRoot.State>
    ) {
        this.timer$ = store.select(fromRoot.getTimer);
        this.timerSubscription = this.timer$.subscribe(timer => {
            this.timer = timer;
        });

        this.timerVisibilitySubscription = store.select(fromRoot.getTimerVisibility).subscribe(visibility => {
            this.isTimerVisible = visibility;
        });
    }

    ngOnDestroy() {
        if (this.timerSubscription) {
            this.timerSubscription.unsubscribe();
        }

        if (this.timerVisibilitySubscription) {
            this.timerVisibilitySubscription.unsubscribe();
        }
    }

    getTimeLeft(): number {
        let timeLeft = 0;
        if (this.timer.timeLimits.MaxTime) {
            const elapsedTimeInSeconds = this.getElapsedTimeInSeconds();
            timeLeft = this.timer.timeLimits.MaxTime - elapsedTimeInSeconds;
            if (timeLeft < 0) {
                timeLeft = 0;
            }
        }
        return timeLeft;
    }

    getDisplayString(timeLeft: number): string {
        let displayString = null;
        if (timeLeft > 0) {
            const duration = moment.duration(timeLeft * 1000);
            const hours = duration.hours();
            const minutes = duration.minutes();
            const seconds = duration.seconds();
            if (hours > 0) {
                displayString = `${this.getHourString(hours)} ${this.getMinuteString(minutes)}`;
            } else {
                if (minutes < 3) {
                    if (minutes > 0) {
                        displayString = `${this.getMinuteString(minutes)} ${this.getSecondString(seconds)}`;
                    } else {
                        displayString = this.getSecondString(seconds);
                    }
                } else {
                    displayString = this.getMinuteString(minutes);
                }
            }
        }
        return displayString;
    }

    canGoNext(): boolean {
         if (this.timer.timeLimits.MinTime) {
            const elapsedTimeInSeconds = this.getElapsedTimeInSeconds();
            return elapsedTimeInSeconds >= this.timer.timeLimits.MinTime;
        }
        return true;
    }

    getElapsedTimeInSeconds(): number {
        if (!this.timer.startedAt) {
            return 0;
        } else {
            const stoppedAt = this.timer.stoppedAt ? this.timer.stoppedAt : new Date().getTime();
            return Math.round((stoppedAt - this.timer.startedAt) / 1000) + this.timer.previouslyUsedTimeInSeconds;
        }
    }

    pauseTimer() {
        this.store.dispatch(new TestTakerActions.PauseTimer());
    }

    unpauseTimer() {
        this.store.dispatch(new TestTakerActions.UnpauseTimer());
    }

    isPaused() {
        return this.timer.pausedAt != null;
    }

    toggleTimerVisibility(visible: boolean) {
        this.store.dispatch(new TestTakerActions.ToggleTimerVisibility(visible));
    }

    startTimer(timeLimits: PgRendererDto.TimeLimits, speakingPreparationTime: number, speakingRecordingTime: number, timerVisibility: boolean, timesUpCallback: Function, showTimesUpWarning: boolean, multiplier: number, timeAlreadyUsed: number) {
        this.store.dispatch(new TestTakerActions.StartTimer(timeLimits, speakingPreparationTime, speakingRecordingTime, timerVisibility, timesUpCallback, showTimesUpWarning, multiplier, timeAlreadyUsed));
    }

    //TDP Web Use Session Storage

    saveTimeUsedOnTestlet(testletId: number) {
        sessionStorage.setItem("TESTLET" + testletId.toString(), this.getElapsedTimeInSeconds().toString());
    }
    getTimeUsedOnTestlet(testletId: number): number {
        const value = sessionStorage.getItem("TESTLET" + testletId.toString());
        if (value) {
            return parseInt(value, 10);
        }else {
            return 0;
        }
    }

    //Private Helpers
    private getHourString(hours: number): string {
        if (hours == 1) {
            return `${hours} hour`;
        } else if (hours > 1) {
            return `${hours} hours`;
        }
        return "";
    }

    private getSecondString(seconds: number): string {
        if (seconds == 1) {
            return `${seconds} second`;
        } else if (seconds > 1) {
            return `${seconds} seconds`;
        }
        return "";
    }

    private getMinuteString(minutes: number): string {
        if (minutes == 1) {
            return `${minutes} minute`;
        } else if (minutes > 1) {
            return `${minutes} minutes`;
        }
        return "";
    }

    

}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/services/timer.service.ts